module.exports = __webpack_public_path__ + "7e9b075b83938e58c87e6a77b8efdd2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/sports/baseball.png
// module id = 1086
// module chunks = 0